export enum ShopState {
  active = 0,
  deleted = 1,
}
